import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function MasterCreatePage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/forex/master-accounts/bind", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-[360px] flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 mx-auto rounded-full bg-primary-500/10 text-primary-500 flex items-center justify-center">
          <i className="ri-loader-4-line animate-spin text-lg" />
        </div>
        <p className="text-sm text-text-primary font-medium mt-3">正在进入主账号绑定流程</p>
        <p className="text-xs text-text-muted mt-1">主账号新增统一由主账号管理中的绑定入口处理。</p>
      </div>
    </div>
  );
}
